<template>
  <v-content>
    <app-navigation-drawer v-if="authorized" v-model="drawer" :permanent="permanent" />

    <v-card flat tile color="transparent" class="mb-4">
      <v-toolbar color="light-green primary" dark extended flat height="68">
        <v-toolbar-side-icon v-if="!permanent" @click="drawer = !drawer" />

        <v-toolbar-title style="width: 240px" class="ml-0 pl-3 white--text hidden-sm-and-down">
          {{ $t('@appShell/headingText') }}
        </v-toolbar-title>

        <template v-if="search">
          <v-spacer />
          <app-search />
          <v-spacer />
          <v-flex shrink class="hidden-sm-and-down" style="width: 220px;" />
        </template>

        <v-btn icon @click="onLogoutClick">
          <v-icon>power_settings_new</v-icon>
        </v-btn>
      </v-toolbar>

      <v-layout row pb-2>
        <v-flex xs12 v-bind="layout">
          <v-card class="card--flex-toolbar">
            <v-toolbar card prominent>
              <v-toolbar-title class="title-2 grey--text text--darken-3">
                {{ title }}
              </v-toolbar-title>

              <v-spacer />
              <slot name="actions" />
            </v-toolbar>

            <v-divider />
            <v-card-text class="pa-0">
              <slot />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card>
  </v-content>
</template>

<style>
.card--flex-toolbar {
  margin-top: -64px;
}
.title-2 {
  font-size: 16px;
}

.v-list--dense .v-list__tile:not(.v-list__tile--avatar) {
  height: 28px;
}

.v-list--dense .v-list__tile {
  font-size: 13px;
}
</style>

<script>
import { mapState } from 'vuex';
import AppNavigationDrawer from './AppNavDrawer';
import AppSearch from './AppSearch';

export default {
  components: { AppNavigationDrawer, AppSearch },

  props: {
    wide: {
      type: Boolean,
      default: false,
    },
    search: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      drawer: false,
    };
  },

  computed: {
    layout() {
      return this.wide
        ? {
            md10: true,
            'offset-md1': true,
          }
        : {
            sm8: true,
            'offset-sm2': true,

            lg6: true,
            'offset-lg3': true,
          };
    },

    permanent() {
      return ['lg', 'xl'].includes(this.$vuetify.breakpoint.name);
    },

    ...mapState({
      authorized: (state) => state.auth.authorized,
    }),
  },

  methods: {
    async onLogoutClick() {
      await this.$store.dispatch('logout');
      this.$router.go('/login');
    },
  },
};
</script>
